import { DatePipe, formatDate } from '@angular/common';
import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { HorseRacingService } from 'src/app/services/horse-racing.service';
import { Country } from '../../enums/countries.enum';
import { SettingsService } from '../../services/settings.service';
@Component({
  selector: 'app-quick-view',
  templateUrl: './quick-view.component.html',
  styleUrls: ['./quick-view.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [DatePipe]
})
export class QuickViewComponent implements OnInit, OnDestroy {

  loading: boolean;
  currentOrientation = 'horizontal';
  todaysBetList;
  today; tomorrow; yesterday;
  format = 'yyyy-MM-dd';
  locale = 'en-US';
  activeIndex = 0;

  private unsubscribeAll$ = new Subject();

  constructor(
    private horseRacingService: HorseRacingService,
    private router: Router,
    private datePipe: DatePipe,
    private settingServ: SettingsService
  ) { }

  async ngOnInit() {
    this.setDates();
    this.getRaces(this.today);
  }

  ngOnDestroy(): void {
    this.unsubscribeAll$.next(null);
    this.unsubscribeAll$.complete();
  }

  setDates(): void {
    this.today = formatDate(new Date(), this.format, this.locale);
    this.yesterday = formatDate(new Date().setDate(new Date().getDate() - 1), this.format, this.locale);
  }

  getRaces(date): void {
    this.loading = true;
    const postData = { date };
    this.horseRacingService.listCountryTracks(postData)
      .pipe(takeUntil(this.unsubscribeAll$))
      .subscribe((data) => {
        this.todaysBetList = data.filter((race) => !this.settingServ.filterRaceCountries(race.country));
        this.loading = false;
        this.activeIndex = data.map((m) => m.country).indexOf('France'); // Is France id always be 4?
      });
  }

  trackRacesRouterLink(country, track, eventId): any {
    return '/races' + '/' + country.replace(/ /g, '-') + '/' + eventId + '/' + track.replace(/ /g, '-');
  }

  getLocalDate(race): any {
    const startTimeUtc = (race.StartTimeUtc !== null && race.StartTimeUtc !== undefined) ? race.StartTimeUtc.replace(/-/g, '/') : undefined;
    const scheduleTimeUtc = (race.ScheduleTimeUtc !== null && race.ScheduleTimeUtc !== undefined) ?
      race.ScheduleTimeUtc.replace(/-/g, '/') : undefined;
    const localDate = (startTimeUtc !== undefined) ? new Date(startTimeUtc + ' UTC') :
      (scheduleTimeUtc !== undefined) ? new Date(scheduleTimeUtc + ' UTC') :
        null;
    return localDate !== null ? this.datePipe.transform(localDate, 'HH:mm') : race.raceTime;
  }

  getRaceType(race, type): 'Trot' | 'Gallop' | 'Greyhound' | 'Dog' {
    return race.IsTrot ? 'Trot' : race.IsGallop ? 'Gallop' : (type === 'icon' ? 'Greyhound' : 'Dog');
  }

  getFlagSlug(country): string {
    const countrySlug = country.replace(/ /g, '');
    const countryCode = Country[countrySlug] !== undefined ? Country[countrySlug] : 'GR';
    const countryCodeLowerCase = countryCode.toLowerCase();
    return 'assets/media/flags/' + countryCodeLowerCase + '.svg';
  }
}
